export enum ADVOCATE_ACCESS_TYPE {
  CREATE,
  READ,
  UPDATE,
  DELETE,
}

export enum ADVOCATE_RESOURCE_TYPE {
  CUSTOMER,
  INVOICE_GROUP, // Billing profile
  SUBSCRIPTION,
  INVOICE,
  INVOICE_CONTACT,
  REFUND,
  ORDER,
  QUOTE,
  BILLING_ADMIN,
  PAYMENT_METHOD,
  SHIP_TO_ADDRESS,
  END_CUSTOMER_CONTACT,
  NOTIFICATION_PREFERENCES,
}

export type ADVOCATE_ACCESS_TYPE_TO_RESOURCE_TYPE_MAP_TYPE = {
  [key in ADVOCATE_ACCESS_TYPE]: ADVOCATE_RESOURCE_TYPE[];
};

export const ADVOCATE_ACCESS_TYPE_TO_RESOURCE_TYPE_MAP: ADVOCATE_ACCESS_TYPE_TO_RESOURCE_TYPE_MAP_TYPE = {
  // Create
  [ADVOCATE_ACCESS_TYPE.CREATE]: [],

  // Read/ View
  [ADVOCATE_ACCESS_TYPE.READ]: [
    ADVOCATE_RESOURCE_TYPE.CUSTOMER,
    ADVOCATE_RESOURCE_TYPE.INVOICE_GROUP,
    ADVOCATE_RESOURCE_TYPE.SUBSCRIPTION,
    ADVOCATE_RESOURCE_TYPE.INVOICE,
    ADVOCATE_RESOURCE_TYPE.INVOICE_CONTACT,
    ADVOCATE_RESOURCE_TYPE.REFUND,
    ADVOCATE_RESOURCE_TYPE.ORDER,
    ADVOCATE_RESOURCE_TYPE.QUOTE,
    ADVOCATE_RESOURCE_TYPE.BILLING_ADMIN,
    ADVOCATE_RESOURCE_TYPE.PAYMENT_METHOD,
    ADVOCATE_RESOURCE_TYPE.SHIP_TO_ADDRESS,
    ADVOCATE_RESOURCE_TYPE.END_CUSTOMER_CONTACT,
    ADVOCATE_RESOURCE_TYPE.NOTIFICATION_PREFERENCES,
  ],

  // Update/ Edit
  [ADVOCATE_ACCESS_TYPE.UPDATE]: [],

  // Delete / Remove
  [ADVOCATE_ACCESS_TYPE.DELETE]: [],
};
